import CoinhouseSolutionsAdmin from "./admin";

const App = () => <CoinhouseSolutionsAdmin />;

export default App;